import React from "react";
import { Navigate } from "react-router-dom";
import { path } from "../Utils/ScreenPath";
import Layout from "../Layout/Layout";

const ProtectedRoute = ({ Component, ...rest }) => {
  let token = localStorage.getItem("token");
  let completeLoginFlow = localStorage.getItem("completeLoginFlow");
  // let LoginUserDetails = JSON.parse(localStorage.getItem("UserDetail"));

  if (token) {
    return (
      <Layout HeadersPath={rest?.HeadersPath}>
        <Component {...rest} />
      </Layout>
    )
  } else {
    return <Navigate to={path?.Login} />;
  }



  //   if (FlowType === "SignIn") {
  //     if (token) {
  //       if (completeLoginFlow) {
  //         return <Navigate to={path?.Dashboard} />;
  //       } else {
  //         return <Component />;
  //       }
  //     } else {
  //       return <Component />;
  //     }
  //   }

  //   if (FlowType === "Dashboard") {
  //     if (token) {
  //       if (completeLoginFlow) {
  //         return <Component />;
  //       } else {
  //         return <Navigate to={path?.Login} />;
  //       }
  //     } else {
  //       return <Navigate to={path?.Registration} />;
  //     }
  //   } else {
  //     return <Navigate to={path?.Registration} />;
  //   }
};
export default ProtectedRoute;
